import { c as __spreadArray } from './_tslib-30326c5e.js';

var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this._listeners = new Map();
    }
    EventEmitter.prototype.add = function (event, listener) {
        var _this = this;
        var _a;
        if (!this._listeners.has(event)) {
            this._listeners.set(event, [listener]);
            return function () { return _this.remove(event, listener); };
        }
        (_a = this._listeners.get(event)) === null || _a === void 0 ? void 0 : _a.push(listener);
        return function () { return _this.remove(event, listener); };
    };
    EventEmitter.prototype.remove = function (event, listener) {
        var _a, _b;
        if (this._listeners.has(event)) {
            this._listeners.set(event, (_b = (_a = this._listeners.get(event)) === null || _a === void 0 ? void 0 : _a.filter(function (l) { return l !== listener; })) !== null && _b !== void 0 ? _b : []);
        }
    };
    EventEmitter.prototype.emit = function (event) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        (_a = this._listeners.get(event)) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) { return listener.apply(void 0, args); });
    };
    return EventEmitter;
}());

var isEventMessage = function (message) {
    return message.type === 'EVENT';
};
var isStatusMessage = function (data) {
    return data.type === 'STATUS';
};

var IFRAME_ID = 'chatik-integration-websocket-iframe';
var WebsocketConnection = /** @class */ (function () {
    function WebsocketConnection() {
        var _this = this;
        this._connected = false;
        this._origin = '';
        this.emitter = new EventEmitter();
        this.connect = function (_a) {
            var origin = _a.origin, _b = _a.handlers, handlers = _b === void 0 ? {} : _b;
            _this._origin = origin;
            var isIframeExists = Boolean(document.getElementById(IFRAME_ID));
            if (!isIframeExists) {
                var iframe = document.createElement('iframe');
                iframe.src = "".concat(_this._origin, "/proxy-webapp/index.html");
                iframe.id = IFRAME_ID;
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
                window.addEventListener('message', _this.handleMessageFromSocketIframe);
            }
            Object.keys(handlers).forEach(function (type) { return _this.on(type, handlers[type]); });
        };
        /** Обработчик сообщения от вебсокет айфрейма */
        this.handleMessageFromSocketIframe = function (event) {
            var _a;
            if (event.origin !== _this._origin) {
                return;
            }
            if (isStatusMessage(event.data)) {
                _this._connected = event.data.data.connected;
                _this.emitter.emit(event.data.data.connected ? 'connect' : 'disconnect');
                return;
            }
            if (isEventMessage(event.data)) {
                switch (event.data.data.eventType) {
                    case 'connect':
                        _this._connected = true;
                        break;
                    case 'disconnect':
                        _this._connected = false;
                        break;
                }
                (_a = _this.emitter).emit.apply(_a, __spreadArray([event.data.data.eventType], [event.data.data.eventData], false));
            }
        };
    }
    Object.defineProperty(WebsocketConnection.prototype, "connected", {
        get: function () {
            return this._connected;
        },
        enumerable: false,
        configurable: true
    });
    WebsocketConnection.prototype.on = function (event, handler) {
        return this.emitter.add(event, handler);
    };
    WebsocketConnection.prototype.off = function (event, handler) {
        this.emitter.remove(event, handler);
    };
    return WebsocketConnection;
}());
var websocket = new WebsocketConnection();

export { websocket as w };
//# sourceMappingURL=WebsocketConnection-98a0364a.js.map
